/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ig-set-approved .dialog-content{height:300px;width:300px}.ig-set-approved .group{padding:2rem}.ig-set-approved .radio-group .mat-radio-button{padding-left:20px}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/set.approved/set.approved.component.scss.ngstyle.js.pre-build-optimizer.js